import { CountFilterType } from '../types';

export const getCountFilterType = (maxCountValue?: number, minCountValue?: number) => {
  if (minCountValue === undefined && maxCountValue === undefined) return CountFilterType.ANY;
  else if (minCountValue === maxCountValue) return CountFilterType.EXACTLY;
  else return CountFilterType.BETWEEN;
};
